import React from "react";
import { Button, InputGroup } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { DelayedFilterInput } from "../../DelayedFilterInput";
import { CyFilterHeader } from "./CyFilterHeader";
import { Column } from "./Column";

interface Props<E> {
  column: Column<E>;
  searchTerm: string | undefined;
  setSearchTerm: (searchTerm: string | undefined) => void;
  visible: boolean;
  orderByButton: React.JSX.Element;
}

export function FilterHeader<E>({
  column,
  searchTerm,
  setSearchTerm,
  visible,
  orderByButton,
}: Props<E>) {
  const isFilterActive = searchTerm !== undefined;

  const searchfieldRef = React.useRef<HTMLInputElement>(null);

  return (
    <InputGroup className={visible ? "" : "d-none"}>
      <Button
        color="primary"
        onClick={() => {
          if (isFilterActive) {
            setSearchTerm(undefined);
          } else {
            setSearchTerm("");
          }
        }}
        className="me-2"
        active={isFilterActive}
        data-cy={CyFilterHeader.ButtonToggleFilter}
      >
        <FontAwesomeIcon icon={faSearch} />
      </Button>
      {isFilterActive ? (
        <DelayedFilterInput
          onSearchTermChanged={setSearchTerm}
          initialValue={searchTerm ?? ""}
          autoFocus={true}
          inputRef={searchfieldRef}
          placeholder={`${column.title} suchen`}
        />
      ) : (
        <>{orderByButton}</>
      )}
    </InputGroup>
  );
}
